import { useContext, useEffect } from "react";
import ls from "local-storage";
import CircularProgress from "@material-ui/core/CircularProgress";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import useInterval from "../../../hooks/useInterval";

import { useThemeStyles } from "../../../styles/themes";
import { FEATURE_TOGGLE_ENABLE_REPAYMENT_EXISTING_FLOW } from "../../../constants/journey";

import "./MandateLoading.scss";

const MandateLoading = () => {
  const classes = useThemeStyles();
  const { state, actions } = useContext(StoreContext);

  const isNewRepaymentFlow = !FEATURE_TOGGLE_ENABLE_REPAYMENT_EXISTING_FLOW;

  const proceedMandateStatus = ({ stopPolling = null, force = false } = {}) => {
    if (state.applicationId) {
      actions.getMandateStatusv2({
        applicationId: state.applicationId,
        ...(force && { enquireMandateStatusFromGateway: true })
      }, (res) => {
        console.debug("getMandateStatusv2 callback", res);
        if (res.status != "PENDING") {
          // stop polling and display result
          stopPolling();

          // Clear mandate cache
          ls.remove("bnplstate");

          if (res.status === "APPROVED") {
            actions.confirmPreAuthSubmission({
              applicationId: state.applicationId,
            });
          } else if (res.status == "FAILED") {
            showMandateFailed();
          }
        }
      });
    } else {
      stopPolling();
      showMandateFailed();
    }
  };

  const { startTimer: startPolling, stopTimer: stopPolling } = useInterval({
    delay: 5,
    intervalBeforeExpire: isNewRepaymentFlow ? 24 : 12, // 24 * 5 seconds = 2 minute
    onExpire: ({ stopTimer }) => {
      if (isNewRepaymentFlow) {
        proceedMandateStatus({ stopPolling: stopTimer, force: true });
      } else {
        showMandatePending();
      }
    },
    executeOnInit: true,
    action: ({ stopTimer }) => {
      if (isNewRepaymentFlow) {
        proceedMandateStatus({ stopPolling: stopTimer });
      } else {
        if (state.applicationId) {
          actions.getMandateStatusv2({
            applicationId: state.applicationId,
          }, (res) => {
            console.debug("getMandateStatusv2 callback", res);
            if (res.status != "PENDING") {
            // stop polling and display result
              stopTimer();

              // Clear mandate cache
              ls.remove("bnplstate");

              if (res.status === "APPROVED") {
                actions.confirmPreAuthSubmission({
                  applicationId: state.applicationId,
                });
              } else if (res.status == "FAILED") {
                showMandateFailed();
              }
            }
          });
        } else {
          stopTimer();
          showMandateFailed();
        }
      }
    },
  });

  const showMandateFailed = () => {
    actions.setStep("MandateFailure");
  };

  const showMandatePending = () => {
    actions.setStep("MandatePending");
  };

  useEffect(() => {
    if (state.applicationId) {
      startPolling();
    } else {
      stopPolling();
      showMandateFailed();
    }
  }, [state.applicationId]);

  return (
    state.prerequisites
      && (
        <>
          <Header />
          <div className="page page-mandate-loading">
            <div className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}>
              <CircularProgress className="respond-loader" size={32} />
              <p className={`${classes.title} center regular title`}>Hang Tight!</p>
              <p className="desc">We're taking you to a secure payment page to complete your transaction.
                Please don’t refresh or close this window.
              </p>
            </div>
            <Footer />
          </div>
        </>
      )
  );
};

export default MandateLoading;
